



<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <transition name="fade">
      <div v-if="show" class="toTop" @click="goToTop">
        <img src="../../../static/gotop.png">
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  methods: {
    goToTop: function() {
      var time = setInterval(function() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;

        window.scrollTo(0, currentScroll - 15);
        if (currentScroll <= 25) {
          clearInterval(time);
        }
      }, 5);
    },
    handler() {
      var clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;

      if (currentScroll > clientHeight * 2) {
        this.show = true;
      } else {
        this.show = false;
      }
    }
  },
  activated() {},
  created() {
    window.location.href = "https://static.998.com/download/DownloadPage.html"
    return
    var url = decodeURIComponent(location.search);
    url = url.replace("?returnURL=", "");
    this.$router.replace({ path: url });

    window.addEventListener("scroll", this.handler);
    var currentUrl = location.href;
    window.addEventListener("hashchange", function() {
      _paq.push(["setReferrerUrl", currentUrl]);
      //console.log(window.location.hash.substr(1));
      currentUrl = "" + window.location.hash.substr(1);
      _paq.push(["setCustomUrl", currentUrl]);
      _paq.push(["setDocumentTitle", location.href]);

      // remove all previously assigned custom variables, requires Piwik 3.0.2
      _paq.push(["deleteCustomVariables", "page"]);
      _paq.push(["setGenerationTimeMs", 0]);
      _paq.push(["trackPageView"]);
    });
  }
};
</script>


<style lang="less"  >
// @import "assets/theme.less";
</style>



// WEBPACK FOOTER //
// App.vue?66a1d2fe